import type { UserProfile } from '@/stores/userStore'
import { defaultAvatarFor } from '@/lib/avatar/startingAvatar'

/** The identity payload Atlas's GameCodex Accounts returns (`account`). */
export interface AtlasAccount {
  id: string
  email: string
  name?: string | null
}

function displayNameFor(account: AtlasAccount): string {
  if (account.name && account.name.trim()) return account.name.trim()
  const local = account.email.split('@')[0] || 'Wanderer'
  return local.charAt(0).toUpperCase() + local.slice(1)
}

/** Deterministic default avatar: an in-world headshot where the world has them. */
function avatarFor(seed: string): string {
  return defaultAvatarFor(seed)
}

/**
 * Map a GameCodex account to our client `UserProfile`.
 *
 * Atlas Accounts *core* returns identity only (id / email / name). Roles and
 * tier are NOT identity — they derive from entitlements (the entitlement-check
 * API, not yet live), so we seed the baseline `player` / `free` here. As ever,
 * these are UI-gating hints only; the server enforces real authorization.
 * See Atlas/_instructions/accounts-integration.md.
 */
export function mapAccount(account: AtlasAccount): UserProfile {
  const displayName = displayNameFor(account)
  return {
    id: account.id,
    email: account.email,
    displayName,
    avatarUrl: avatarFor(displayName || account.email),
    backstory: null,
    isPublic: true,
    roles: ['player'],
    tier: 'free',
    createdAt: new Date().toISOString(),
  }
}
